import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {utils_tool, component_tool, framework_tool} from '../../../../tool'
import {WizTableForm, WizDataAuthSelect} from '@/containers/common'

let {WizButton, WizCard, WizAntdForm, WizRow, WizCol} = component_tool
let {WizContainer} = framework_tool

class ExamAuthSelect extends Component {

  componentName = 'examAuthSelect';

  constructor(props) {
    super(props);
    this.state = {}
  }

  handleSubmit(status) {
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        let {submit} = this.props
        submit && submit(values, status)
      }
    });
  };

  /**
   * 重置表单
   */
  handleReset = () => {
    //重置表单
    this.props.form.resetFields();
  };

  handlePrev(values){
    let {prev} = this.props
    prev && prev(values)
  }

  render() {
    //examTemplateGroupInfo
    let {form, title, initialValue, value,path,examTemplateGroupInfo} = this.props
    if (path && path=== '/online/examTemplateGroup/examTemplateAuth'){
      return (
        <WizAntdForm>
          {
            form.getFieldDecorator('dataAuth', {initialValue:Object.assign({}, initialValue)})(
              <WizDataAuthSelect/>
            )
          }
          <WizAntdForm.Item wrapperCol={{span: 12, offset: 6}}>
            <WizRow>
              <WizCol span={24} style={{textAlign: 'center'}}>
                <WizButton title="上一步" onClick={e => this.handlePrev(examTemplateGroupInfo)}>上一步</WizButton>
                <WizButton style={{marginLeft: 20}} htmlType="submit" onClick={e => this.handleSubmit(null)}>
                  保存并返回
                </WizButton>
                <WizButton style={{marginLeft: 20}} onClick={this.handleReset}>
                  重置
                </WizButton>
              </WizCol>
            </WizRow>
          </WizAntdForm.Item>
        </WizAntdForm>

      )
    } else {
      return (
        <WizAntdForm>
          {
            form.getFieldDecorator('dataAuth', {initialValue: Object.assign({}, initialValue)})(
              <WizDataAuthSelect/>
            )
          }
          <WizAntdForm.Item wrapperCol={{span: 12, offset: 6}}>
            <WizRow>
              <WizCol span={24} style={{textAlign: 'center'}}>
                <WizButton title="上一步" onClick={e => window.history.back()}>上一步</WizButton>
                <WizButton type="primary" style={{marginLeft: 20}} htmlType="submit" onClick={e => this.handleSubmit(1)}>
                  保存并发布
                </WizButton>
                <WizButton style={{marginLeft: 20}} htmlType="submit" onClick={e => this.handleSubmit(null)}>
                  保存并返回
                </WizButton>
                <WizButton style={{marginLeft: 20}} onClick={this.handleReset}>
                  重置
                </WizButton>
              </WizCol>
            </WizRow>
          </WizAntdForm.Item>
        </WizAntdForm>

      )
    }

  }

}

export default WizAntdForm.create()(ExamAuthSelect);

/**
 * 默认值
 */
ExamAuthSelect.defaultProps = {
  title: '数据权限选择',

}
/**
 * props入参校验
 */
ExamAuthSelect.propTypes = {
  title: PropTypes.string.isRequired,//卡片标题
  submit: PropTypes.fun,//提交的回调方法
}
